import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { ROUTE_CONSTANTS } from '../../utils'

const ProtectedRoute = ({ component: Component, ...restOfProps }) => {
	return (
		<Route
			{...restOfProps}
			render={(props) =>
				process.env.REACT_APP_MAINTENANCE_MODE ? (
					<Redirect to={ROUTE_CONSTANTS.STATUS} />
				) : (
					<Component {...props} />
				)
			}
		/>
	)
}
export default ProtectedRoute
